import { showErrorToast, showSuccessToast } from '@slr/shared-library';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePlatformAdminOffersApi } from 'services/admin/usePlatformAdminOffersApi';
import { PLATFORM_ADMIN_OFFERS_QUERY_KEY } from './useSearchPlatformAdminOffers';

export const useSuspendPlatformAdminOffer = () => {
  const { suspendOffer } = usePlatformAdminOffersApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      roomId,
      reason,
      messageToProvider
    }: {
      roomId: string;
      reason: string;
      messageToProvider?: string;
    }) => suspendOffer(roomId, { reason, messageToProvider }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PLATFORM_ADMIN_OFFERS_QUERY_KEY]
      });
      showSuccessToast('toasts.platformAdminOffers.suspended');
    },
    onError: () => {
      showErrorToast('toasts.platformAdminOffers.actionFailed');
    }
  });
};

export const useUnsuspendPlatformAdminOffer = () => {
  const { unsuspendOffer } = usePlatformAdminOffersApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ roomId }: { roomId: string }) => unsuspendOffer(roomId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PLATFORM_ADMIN_OFFERS_QUERY_KEY]
      });
      showSuccessToast('toasts.platformAdminOffers.unsuspended');
    },
    onError: () => {
      showErrorToast('toasts.platformAdminOffers.actionFailed');
    }
  });
};

export const useRemovePlatformAdminOffer = () => {
  const { removeOffer } = usePlatformAdminOffersApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      roomId,
      reason,
      messageToProvider
    }: {
      roomId: string;
      reason: string;
      messageToProvider?: string;
    }) => removeOffer(roomId, { reason, messageToProvider }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PLATFORM_ADMIN_OFFERS_QUERY_KEY]
      });
      showSuccessToast('toasts.platformAdminOffers.removed');
    },
    onError: () => {
      showErrorToast('toasts.platformAdminOffers.actionFailed');
    }
  });
};
